import { Link, useNavigate } from "react-router-dom";
import "./Under.css";
import logo from "../../Photos/logo.png"
import { useEffect } from "react";
const UnderConstruction = () => {
    const navigate = useNavigate();
    // useEffect(() => {
    //     document.title = "Scaleup Academy";

    //     // If you want automatic redirect to home:
    //     navigate("/");
    // }, []);

    return (<>
        <div className="underPage">
            <h1>Coming Soon!</h1>
            <p className="subText">Stay Tuned</p>
            <div className="aboutUnder">
                <img src={logo} alt="logo" />
                <Link >www.scale-upacademy.com</Link>
                <div className="address">
                    <p>9867733552</p>
                    <p>Chipledhunga, Pokhara</p>
                </div>
            </div>
        </div>
    </>)
}
export default UnderConstruction